export const LOGS_POLLING = 1000 * 30;
export const LOGS_LIMIT = 10;
export const LOG_DETAILS_SECTIONS = ['result', 'detailed log', 'log results'];
export const LOG_DETAILS_SECTIONS_NOT_LOG_RESULTS = ['result', 'detailed log'];
